import { useState } from "react";
import { throwResponseError } from "../../../../utils/api-error-utils";
import { getAuthParams } from "../../../../utils/pacto-rebates-utils";
import { formatDeclineNetSalesPayload, formatDeclineNetSalesResponse, validateDeclineNetSalesPayload } from "../../../utils/decline-net-sales-utils";

export function useDeclineNetSalesNew() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    const validateDeclineNetSales = values => {
        const errors = validateDeclineNetSalesPayload(values);

        setValidationErrors(errors);

        return errors;
    };

    async function createDeclineNetSales(payloadData) {
        const errors = validateDeclineNetSales(payloadData);

        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            setError(null);

            return {
                ok: false,
                reason: "validation",
                validationErrors: errors
            };
        }

        try {
            setLoading(true);
            setError(null);
            setValidationErrors({});

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const body = formatDeclineNetSalesPayload(payloadData);

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                },
                body: JSON.stringify(body)
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/penalidades-queda-grupo`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível salvar a penalidade por queda em Net Sales (Grupo)."
                );
            }

            const data = await response.json();

            const declineNetSalesData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedDeclineNetSales = formatDeclineNetSalesResponse(declineNetSalesData);

            return {
                ok: true,
                declineNetSales: formattedDeclineNetSales
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        validationErrors,
        validateDeclineNetSales,
        createDeclineNetSales
    };
}